import React from 'react';
import CookieConsent from 'react-cookie-consent';

const CookieConsentBanner: React.FC = () => {
  const handleAccept = () => {
    // Enable Google Analytics when user accepts
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDecline = () => {
    // Disable Google Analytics when user declines
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={handleAccept}
      onDecline={handleDecline}
      style={{
        background: "#254E97",
        fontSize: "14px",
        padding: "15px"
      }}
      buttonStyle={{
        background: "#fff",
        color: "#254E97",
        fontSize: "13px",
        fontWeight: "bold",
        borderRadius: "5px",
        padding: "8px 16px"
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#fff",
        fontSize: "13px",
        border: "1px solid #fff",
        borderRadius: "5px",
        padding: "8px 16px",
        marginRight: "10px"
      }}
      expires={365}
    >
      <span style={{ fontSize: "14px" }}>
        This website uses cookies to enhance your browsing experience and to analyze our traffic. 
        By clicking "Accept All", you consent to our use of cookies.{" "}
        <a href="/privacy-policy" style={{ color: "#fff", textDecoration: "underline" }}>
          Learn more
        </a>
      </span>
    </CookieConsent>
  );
};

export default CookieConsentBanner;